import React from 'react';

export interface ContainerBlurProps {
  children: React.ReactNode;
  clickaway: () => void;
  className?: string;
}

const ContainerBlur = (props: ContainerBlurProps) => {
  return (
    <>
      <div
        onClick={event => {
          event.stopPropagation();
        }}
        className={
          'pt-4 px-6 rounded-2xl bg-neutral-chalk/[0.92] backdrop-blur-sm shadow-[0_3px_15px_0_#27AAE166] max-lg:max-h-[calc(100vh-187px)] max-h-[calc(100vh-100px)] ' +
          (props.className ?? '')
        }
      >
        {props.children}
      </div>
      <div
        className={'fixed w-full h-full top-0 left-0 bg-transparent -z-10'}
        onClick={props.clickaway}
      ></div>
    </>
  );
};

export default ContainerBlur;
